// import Footer from "../standartComponent/footer/footer";
// import Header from "../standartComponent/header/header";
// import css from "./priceOpt.module.css";
// import optBirdFirst from "../../img/optBirdFirst.png";
// import optBirdSecond from "../../img/optBirdSecond.png";
// import optBirdTherd from "../../img/optBirdThre.png";
// import optBirdFour from "../../img/optBirdFour.png";
// import optBirdFive from "../../img/optBirdFive.png";
// import optBirdSix from "../../img/optBirdSix.png";
// import arrowBirdOpt from "../../img/arrowBirdOpt.png";
// import ElectroObig from "./electoObig";
// import { collection, getDocs, query, orderBy } from "firebase/firestore";
// import { db } from "../../firebase";
// import { useEffect, useState } from "react";
// import ProductInOpt from "./productInOpt";
// import LitShow from "../standartComponent/litShow/litShow";
// import ActionsAnd from "./actionsAnd";

// export default function PriceOpt({ windowDimensions, setCartCounterC }) {
//   const [productsData, setProductsData] = useState([]);
//   const [obj, setObj] = useState([]);
//   const [haveProduct, setHaveProduct] = useState(false);
//   const [totalSum, setTotalSum] = useState(0);

//   useEffect(() => {
//     const getArrayValue = (value) => {
//       if (Array.isArray(value)) return value;

//       if (typeof value === "string" && value.trim() !== "") {
//         return [value];
//       }

//       return [];
//     };

//     const getAuthorsBySurname = (value) => {
//       return getArrayValue(value)
//         .map((item) => item.split(" ")[0]?.trim())
//         .filter(Boolean);
//     };

//     const isActiveByDate = (item) => {
//       const now = new Date();

//       const start = item.startDate ? new Date(item.startDate) : null;
//       const end = item.endDate ? new Date(item.endDate) : null;

//       if (start && now < start) return false;
//       if (end && now > end) return false;

//       return true;
//     };

//     const isProductInAppliesTo = (product, appliesTo = {}) => {
//       const productSeries = [
//         ...getArrayValue(product.seria),
//         ...getArrayValue(product.series),
//       ];

//       const productAuthors = getAuthorsBySurname(product.textAutor);

//       const matchProduct =
//         Array.isArray(appliesTo.products) &&
//         appliesTo.products.some(
//           (pid) => pid === product.uid || pid === product.id,
//         );

//       const matchSeries =
//         Array.isArray(appliesTo.series) &&
//         productSeries.some((ser) => appliesTo.series.includes(ser));

//       const actionAuthors = Array.isArray(appliesTo.authors)
//         ? appliesTo.authors
//             .map((author) => author.split(" ")[0]?.trim())
//             .filter(Boolean)
//         : [];

//       const matchAuthor = productAuthors.some((author) =>
//         actionAuthors.includes(author),
//       );

//       return matchProduct || matchSeries || matchAuthor;
//     };

//     const applyDiscountsToProduct = (product, sales, actions) => {
//       let updatedProduct = { ...product };

//       const matchedSale = sales.find((sale) => {
//         return (
//           isActiveByDate(sale) &&
//           isProductInAppliesTo(updatedProduct, sale.appliesTo)
//         );
//       });

//       if (matchedSale) {
//         const discount = Number(matchedSale.discountPercent) || 0;
//         const basePrice = Number(updatedProduct.price) || 0;

//         const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

//         updatedProduct = {
//           ...updatedProduct,
//           saleDiscountPercent: discount,
//           salePrice: newPrice,
//         };
//       }

//       const matchedAction = actions.find((action) => {
//         return (
//           isActiveByDate(action) &&
//           isProductInAppliesTo(updatedProduct, action.appliesTo)
//         );
//       });

//       if (matchedAction) {
//         const discount = Number(matchedAction.discountPercent) || 0;
//         const basePrice = Number(updatedProduct.price) || 0;

//         const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

//         updatedProduct = {
//           ...updatedProduct,
//           actionDiscountPercent: discount,
//           actionPrice: newPrice,
//         };
//       }

//       return updatedProduct;
//     };

//     const fetchData = async () => {
//       try {
//         const seriesRef = collection(db, "series");
//         const seriesQuery = query(seriesRef, orderBy("sortOrder", "asc"));
//         const seriesSnapshot = await getDocs(seriesQuery);

//         const dynamicObj = seriesSnapshot.docs
//           .map((doc) => ({
//             id: doc.id,
//             arr: [],
//             ...doc.data(),
//           }))
//           .filter((item) => item.isActive !== false);

//         setObj(dynamicObj);

//         const productsSnapshot = await getDocs(collection(db, "product"));
//         const products = productsSnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         const salesSnapshot = await getDocs(collection(db, "sales"));
//         const sales = salesSnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         const actionsSnapshot = await getDocs(collection(db, "actions"));
//         const actions = actionsSnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         const productsWithDiscounts = products.map((product) =>
//           applyDiscountsToProduct(product, sales, actions),
//         );

//         const updatedProductsData = dynamicObj.reduce((acc, item) => {
//           const matchingProducts = productsWithDiscounts.filter((product) => {
//             if (Array.isArray(product.seria)) {
//               return product.seria.includes(item.name);
//             }

//             return product.seria === item.name;
//           });

//           if (matchingProducts.length > 0) {
//             acc.push({
//               name: item.name,
//               desc: item.desc,
//               products: matchingProducts,
//             });
//           }

//           return acc;
//         }, []);

//         setProductsData(updatedProductsData);
//       } catch (error) {
//         console.error(
//           "Помилка при отриманні серій, товарів або знижок:",
//           error,
//         );
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const getProductCurrentPrice = (product) => {
//       if (product?.priceSale && product.priceSale !== "") {
//         return Number(product.price) || 0;
//       }

//       if (product?.salePrice) {
//         return Number(product.salePrice) || 0;
//       }

//       if (product?.actionPrice) {
//         return Number(product.actionPrice) || 0;
//       }

//       return Number(product?.price) || 0;
//     };

//     const calculateTotalSum = () => {
//       let sum = 0;

//       const storedCart = localStorage.getItem("cart");

//       if (storedCart) {
//         const cartItems = JSON.parse(storedCart);

//         productsData.forEach((category) => {
//           category.products.forEach((product) => {
//             const cartProduct = cartItems.find(
//               (item) => item.uid === product.uid,
//             );

//             if (cartProduct) {
//               const quantity = Number(cartProduct.quantity) || 0;
//               const currentPrice = getProductCurrentPrice(product);

//               sum += currentPrice * quantity;
//             }
//           });
//         });
//       }

//       setTotalSum(sum);
//     };

//     calculateTotalSum();
//   }, [haveProduct, productsData]);

//   return (
//     <div>
//       <div className={css.titleWrap}>
//         <h3 className={css.h3Title}>
//           На цій сторінці зручно робити гуртові замовлення
//         </h3>

//         {windowDimensions && (
//           <>
//             <div className={css.birdWrapFirst}>
//               <div className={css.birdWrap}>
//                 <img src={optBirdFirst} alt="" />
//                 <p className={css.birdPDesc}>
//                   В графі “замовлення” проставте кількість
//                 </p>
//               </div>

//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

//               <div className={css.birdWrap}>
//                 <img src={optBirdSecond} alt="" />
//                 <p className={css.birdPDesc}>
//                   В кінці прайсу тицьніть на кнопку “замовити” і в кошик буде
//                   додано одразу всі книги, навпроти яких у графі “замовлення”
//                   стоїть цифра
//                 </p>
//               </div>

//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

//               <div className={css.birdWrap}>
//                 <img src={optBirdTherd} alt="" />
//                 <p className={css.birdPDesc}>
//                   Прямо з кошика можна відкоригувати замовлення, додати або
//                   видалити примірники книг
//                 </p>
//               </div>

//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />
//             </div>

//             <div className={css.birdWrapSecond}>
//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

//               <div className={css.birdWrap}>
//                 <img src={optBirdFour} alt="" />
//                 <p className={css.birdPDesc}>
//                   Ваша гуртова знижка підтягнеться автоматично, треба лише
//                   увійти в свій акаунт
//                 </p>
//               </div>

//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

//               <div className={css.birdWrap}>
//                 <img src={optBirdFive} alt="" />
//                 <p className={css.birdPDesc}>
//                   Якщо у вас відсутній акаунт, але ви хочете долучитись до
//                   розповсюдження книг видавництва, зареєструєтесь як партнер у
//                   одній з запропонованих ролей і ви отримаєте персональну знижку
//                 </p>
//               </div>

//               <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

//               <div className={css.birdWrap}>
//                 <img src={optBirdSix} alt="" />
//                 <p className={css.birdPDesc}>
//                   Кожен рядок інтерактивний. Ви можете перейти з нього на
//                   сторінку книги та дізнатись про неї більше, подивитись відео
//                   чи опис книги
//                 </p>
//               </div>
//             </div>
//           </>
//         )}

//         {!windowDimensions && (
//           <div className={css.birdWrap}>
//             <img src={optBirdFirst} alt="" />
//             <p className={css.birdPDesc}>
//               В графі “замовлення” проставте кількість
//             </p>
//           </div>
//         )}
//       </div>

//       <div className={css.blockTextWrap}>
//         <div className={css.blockTextWrapSmall}>
//           <p className={css.pBlockTextWrap}>
//             Ми продаємо книги, як місіонери. Тобто продаємо лише ті книги, що
//             мають в собі меседж, і наше завдання донести цей меседж до людини.
//             Якщо меседж її “торкне”, вона купить книгу та прийде знов у
//             майбутньому. Наша мета — не продати книгу, а донести її головну
//             ідею. Якщо ви розповсюджуєте наші книжки, ми радимо читати їх або як
//             мінімум дивитись відео, в яких ми доносимо меседж кожного видання. В
//             такому разі ви зможете донести цей меседж до покупців. Якщо
//             продавець знає книгу та чим вона може прорости в дитині, це значно
//             підвищує продажі. Це не теорія — це наш досвід, перевірений на
//             практиці.
//           </p>

//           <h1 className={css.timeToChas}>Настав час майстрів!</h1>
//         </div>
//       </div>

//       <ActionsAnd />

//       {productsData.map((item, index) => (
//         <div key={item.name || index} className={css.theBestForChildren}>
//           <h5 className={css.theBestForChildrenH5}>{item.name}</h5>

//           <p className={css.theBestForChildrenP}>{item.desc}</p>

//           <div className={css.needProductWrap}>
//             {item.products.map((el) => (
//               <ProductInOpt
//                 key={el.uid || el.id}
//                 el={el}
//                 setCartCounterC={setCartCounterC}
//                 setHaveProduct={setHaveProduct}
//                 haveProduct={haveProduct}
//               />
//             ))}
//           </div>

//           {index === productsData.length - 1 && (
//             <div className={css.bestForChildrenWrapEnd}>
//               <h2 className={css.priceOptH2}>Всього: {totalSum} грн</h2>
//               <button className={css.buttonOrderOpt}>Замовити</button>
//             </div>
//           )}
//         </div>
//       ))}

//       <ElectroObig />

//       <LitShow />
//     </div>
//   );
// }

import Footer from "../standartComponent/footer/footer";
import Header from "../standartComponent/header/header";
import css from "./priceOpt.module.css";
import optBirdFirst from "../../img/optBirdFirst.png";
import optBirdSecond from "../../img/optBirdSecond.png";
import optBirdTherd from "../../img/optBirdThre.png";
import optBirdFour from "../../img/optBirdFour.png";
import optBirdFive from "../../img/optBirdFive.png";
import optBirdSix from "../../img/optBirdSix.png";
import arrowBirdOpt from "../../img/arrowBirdOpt.png";
import ElectroObig from "./electoObig";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";
import { useEffect, useState } from "react";
import ProductInOpt from "./productInOpt";
import LitShow from "../standartComponent/litShow/litShow";
import ActionsAnd from "./actionsAnd";
import { useNavigate } from "react-router-dom";
export default function PriceOpt({ windowDimensions, setCartCounterC }) {
  const [productsData, setProductsData] = useState([]);
  const [obj, setObj] = useState([]);
  const [haveProduct, setHaveProduct] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [cartVersion, setCartVersion] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const handleCartUpdated = () => {
      setCartVersion((prev) => prev + 1);
    };

    window.addEventListener("cartUpdated", handleCartUpdated);
    window.addEventListener("storage", handleCartUpdated);
    window.addEventListener("focus", handleCartUpdated);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdated);
      window.removeEventListener("storage", handleCartUpdated);
      window.removeEventListener("focus", handleCartUpdated);
    };
  }, []);
  useEffect(() => {
    const getArrayValue = (value) => {
      if (Array.isArray(value)) return value;

      if (typeof value === "string" && value.trim() !== "") {
        return [value];
      }

      return [];
    };

    const getAuthorsBySurname = (value) => {
      return getArrayValue(value)
        .map((item) => item.split(" ")[0]?.trim())
        .filter(Boolean);
    };

    const isActiveByDate = (item) => {
      const now = new Date();

      const start = item.startDate ? new Date(item.startDate) : null;
      const end = item.endDate ? new Date(item.endDate) : null;

      if (start && now < start) return false;
      if (end && now > end) return false;

      return true;
    };

    const isProductInAppliesTo = (product, appliesTo = {}) => {
      const productSeries = [
        ...getArrayValue(product.seria),
        ...getArrayValue(product.series),
      ];

      const productAuthors = getAuthorsBySurname(product.textAutor);

      const matchProduct =
        Array.isArray(appliesTo.products) &&
        appliesTo.products.some(
          (pid) => pid === product.uid || pid === product.id,
        );

      const matchSeries =
        Array.isArray(appliesTo.series) &&
        productSeries.some((ser) => appliesTo.series.includes(ser));

      const actionAuthors = Array.isArray(appliesTo.authors)
        ? appliesTo.authors
            .map((author) => author.split(" ")[0]?.trim())
            .filter(Boolean)
        : [];

      const matchAuthor = productAuthors.some((author) =>
        actionAuthors.includes(author),
      );

      return matchProduct || matchSeries || matchAuthor;
    };

    const applyDiscountsToProduct = (product, sales, actions) => {
      let updatedProduct = { ...product };

      const matchedSale = sales.find((sale) => {
        return (
          isActiveByDate(sale) &&
          isProductInAppliesTo(updatedProduct, sale.appliesTo)
        );
      });

      if (matchedSale) {
        const discount = Number(matchedSale.discountPercent) || 0;
        const basePrice = Number(updatedProduct.price) || 0;

        const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

        updatedProduct = {
          ...updatedProduct,
          saleDiscountPercent: discount,
          salePrice: newPrice,
        };
      }

      const matchedAction = actions.find((action) => {
        return (
          isActiveByDate(action) &&
          isProductInAppliesTo(updatedProduct, action.appliesTo)
        );
      });

      if (matchedAction) {
        const discount = Number(matchedAction.discountPercent) || 0;
        const basePrice = Number(updatedProduct.price) || 0;

        const newPrice = Math.round(basePrice - (basePrice * discount) / 100);

        updatedProduct = {
          ...updatedProduct,
          actionDiscountPercent: discount,
          actionPrice: newPrice,
        };
      }

      return updatedProduct;
    };

    const fetchData = async () => {
      try {
        const seriesRef = collection(db, "series");
        const seriesQuery = query(seriesRef, orderBy("sortOrder", "asc"));
        const seriesSnapshot = await getDocs(seriesQuery);

        const dynamicObj = seriesSnapshot.docs
          .map((doc) => ({
            id: doc.id,
            arr: [],
            ...doc.data(),
          }))
          .filter((item) => item.isActive !== false);

        setObj(dynamicObj);

        const productsSnapshot = await getDocs(collection(db, "product"));
        const products = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const salesSnapshot = await getDocs(collection(db, "sales"));
        const sales = salesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const actionsSnapshot = await getDocs(collection(db, "actions"));
        const actions = actionsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const productsWithDiscounts = products.map((product) =>
          applyDiscountsToProduct(product, sales, actions),
        );

        const updatedProductsData = dynamicObj.reduce((acc, item) => {
          const matchingProducts = productsWithDiscounts
            .filter((product) => {
              if (Array.isArray(product.seria)) {
                return product.seria.includes(item.name);
              }

              return product.seria === item.name;
            })
            .sort((a, b) => {
              const nameA = a.bookName || "";
              const nameB = b.bookName || "";

              return nameA.localeCompare(nameB, "uk", {
                sensitivity: "base",
                numeric: true,
              });
            });

          if (matchingProducts.length > 0) {
            acc.push({
              name: item.name,
              desc: item.desc,
              products: matchingProducts,
            });
          }

          return acc;
        }, []);

        setProductsData(updatedProductsData);
      } catch (error) {
        console.error(
          "Помилка при отриманні серій, товарів або знижок:",
          error,
        );
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const getProductCurrentPrice = (product) => {
      if (product?.priceSale && product.priceSale !== "") {
        return Number(product.price) || 0;
      }

      if (product?.salePrice) {
        return Number(product.salePrice) || 0;
      }

      if (product?.actionPrice) {
        return Number(product.actionPrice) || 0;
      }

      return Number(product?.price) || 0;
    };

    const calculateTotalSum = () => {
      let sum = 0;

      const storedCart = localStorage.getItem("cart");

      if (storedCart) {
        const cartItems = JSON.parse(storedCart);

        productsData.forEach((category) => {
          category.products.forEach((product) => {
            const cartProduct = cartItems.find(
              (item) => item.uid === product.uid,
            );

            if (cartProduct) {
              const quantity = Number(cartProduct.quantity) || 0;
              const currentPrice = getProductCurrentPrice(product);

              sum += currentPrice * quantity;
            }
          });
        });
      }

      setTotalSum(sum);
    };

    calculateTotalSum();
  }, [haveProduct, productsData, cartVersion]);

  return (
    <div>
      <div className={css.titleWrap}>
        <h3 className={css.h3Title}>
          На цій сторінці зручно робити гуртові замовлення
        </h3>

        {windowDimensions && (
          <>
            <div className={css.birdWrapFirst}>
              <div className={css.birdWrap}>
                <img src={optBirdFirst} alt="" />
                <p className={css.birdPDesc}>
                  В графі “замовлення” проставте кількість
                </p>
              </div>

              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

              <div className={css.birdWrap}>
                <img src={optBirdSecond} alt="" />
                <p className={css.birdPDesc}>
                  В кінці прайсу тицьніть на кнопку “замовити” і в кошик буде
                  додано одразу всі книги, навпроти яких у графі “замовлення”
                  стоїть цифра
                </p>
              </div>

              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

              <div className={css.birdWrap}>
                <img src={optBirdTherd} alt="" />
                <p className={css.birdPDesc}>
                  Прямо з кошика можна відкоригувати замовлення, додати або
                  видалити примірники книг
                </p>
              </div>

              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />
            </div>

            <div className={css.birdWrapSecond}>
              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

              <div className={css.birdWrap}>
                <img src={optBirdFour} alt="" />
                <p className={css.birdPDesc}>
                  Ваша гуртова знижка підтягнеться автоматично, треба лише
                  увійти в свій акаунт
                </p>
              </div>

              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

              <div className={css.birdWrap}>
                <img src={optBirdFive} alt="" />
                <p className={css.birdPDesc}>
                  Якщо у вас відсутній акаунт, але ви хочете долучитись до
                  розповсюдження книг видавництва, зареєструєтесь як партнер у
                  одній з запропонованих ролей і ви отримаєте персональну знижку
                </p>
              </div>

              <img src={arrowBirdOpt} className={css.arrowBirdOptSt} alt="" />

              <div className={css.birdWrap}>
                <img src={optBirdSix} alt="" />
                <p className={css.birdPDesc}>
                  Кожен рядок інтерактивний. Ви можете перейти з нього на
                  сторінку книги та дізнатись про неї більше, подивитись відео
                  чи опис книги
                </p>
              </div>
            </div>
          </>
        )}

        {!windowDimensions && (
          <div className={css.birdWrap}>
            <img src={optBirdFirst} alt="" />
            <p className={css.birdPDesc}>
              В графі “замовлення” проставте кількість
            </p>
          </div>
        )}
      </div>

      <div className={css.blockTextWrap}>
        <div className={css.blockTextWrapSmall}>
          <p className={css.pBlockTextWrap}>
            Ми продаємо книги, як місіонери. Тобто продаємо лише ті книги, що
            мають в собі меседж, і наше завдання донести цей меседж до людини.
            Якщо меседж її “торкне”, вона купить книгу та прийде знов у
            майбутньому. Наша мета — не продати книгу, а донести її головну
            ідею. Якщо ви розповсюджуєте наші книжки, ми радимо читати їх або як
            мінімум дивитись відео, в яких ми доносимо меседж кожного видання. В
            такому разі ви зможете донести цей меседж до покупців. Якщо
            продавець знає книгу та чим вона може прорости в дитині, це значно
            підвищує продажі. Це не теорія — це наш досвід, перевірений на
            практиці.
          </p>

          <h1 className={css.timeToChas}>Настав час майстрів!</h1>
        </div>
      </div>

      <ActionsAnd />

      {productsData.map((item, index) => (
        <div key={item.name || index} className={css.theBestForChildren}>
          <h5 className={css.theBestForChildrenH5}>{item.name}</h5>

          <p className={css.theBestForChildrenP}>{item.desc}</p>

          <div className={css.needProductWrap}>
            {item.products.map((el) => (
              <ProductInOpt
                key={el.uid || el.id}
                el={el}
                setCartCounterC={setCartCounterC}
                setHaveProduct={setHaveProduct}
                haveProduct={haveProduct}
              />
            ))}
          </div>

          {index === productsData.length - 1 && (
            <div className={css.bestForChildrenWrapEnd}>
              <h2 className={css.priceOptH2}>Всього: {totalSum} грн</h2>
              <button
                className={css.buttonOrderOpt}
                onClick={() => navigate("/cart")}
              >
                Замовити
              </button>{" "}
            </div>
          )}
        </div>
      ))}

      <ElectroObig />

      <LitShow />
    </div>
  );
}
